import React from 'react';

import moment from 'moment';

export const options = {
  columns: [
    { id: 1, name: 'sno', label: 'S.No.', sortable: true, type: 'number', expand: true, },
    { id: 2, name: 'advertiser', label: 'Advertiser', sortable: true, type: 'string' },
    {
      id: 3, name: 'platform', label: 'DSP Platform', sortable: true, type: 'string', component: (row) =>
        row.platforms.map(item => item.accountList.length > 0 ? item.accountList.map(acc => <div className='text-row'>{item.platform}</div>) : ""
        )
    },
    {
      id: 4, name: 'accountId', label: 'Account ID', sortable: true, type: 'number', component: (row) =>
        row.platforms.map(item => item.accountList.length > 0 ? item.accountList.map(acc => <div className='text-row'>{acc.accountId}</div>) : ""
        )
    },
    {
      id: 5, name: 'currency', label: 'Currency', sortable: true, type: 'string', component: (row) =>
        row.platforms.map(item => item.accountList.length > 0 ? item.accountList.map(acc => <div className='text-row'>{acc.currency}</div>) : ""
        )
    },
    // { id: 6, name: 'budgetName', label: 'Options', sortable: true, type: 'string' },
    // <div className='text-left'>{row.platforms.map((e, index) => e.platform)}</div>
    // { id: 6, name: 'startDate', label: 'Start Date', sortable: true, type: 'date', component: (row) => moment(row.startDate).format('DD-MMM-YY') },
    // // { id: 7, name: 'endDate', label: 'End Date', sortable: true, type: 'date', component: (row) => moment(row.endDate).format('DD-MMM-YY') },
    // { id: 7, name: 'endDate', label: 'End Date', sortable: true, type: 'date', component: (row) => row.endDate ? moment(row.endDate).format('DD-MMM-YY') : '' },
  ],
  // keyCol: 'ioNo',
  actions: [{
    type: 'edit',
    text: '',
    icon: 'mdi mdi-pencil',
    tooltip: 'Edit'
  }, 
  // {
  //   type: 'delete',
  //   text: '',
  //   icon: 'mdi mdi-delete',
  //   tooltip: 'Delete',
  //   confirmation: true,
  //   confirmationMessage: 'Kindly confirm the deletion of this record. This action cannot be undone.',
  // }
],
  // recActive: true,
  // status: {
  //   key: 'rec_active',
  //   active: '1',
  //   activeIcon: 'mdi mdi-checkbox-marked',
  //   inActiveIcon: 'mdi mdi-close-box',
  //   confirmation: true,
  //   activeConfirmationMessage: 'Kindly confirm the deactivation of this record.',
  //   inActiveConfirmationMessage: 'Please confirm if you wish to activate this record.',
  // },
  actionsThead: true,
  // sortable: true,
  // dateType: true,
  // defaultSortParams: {
  //   sortBy: 'date',
  //   sortOrder: 'asc'
  // },
  // paging: false,
  // defaultPagingParams: {
  //   pageSize: 25
  // }
};

// export const bidderReport = [
//   { ioNo: 1, advertiser: '1', ioname: 'June-Shriram', iobrief: 'HNI property- lead generation- karnataka', iobudget: 10000, startDate: '2019-10-15', endDate: '2019-10-18' },
//   { ioNo: 2, advertiser: '2', ioname: 'June- Great Learning', iobrief: 'Lead generation- online courses- Pan India', iobudget: 10000, startDate: '2019-10-15', endDate: '2019-10-17' },
//   { ioNo: 3, advertiser: '3', ioname: 'ceregrew', iobrief: 'HNI property- lead generation- Gujarat', iobudget: 10000, startDate: '2019-10-16', endDate: '2019-10-19' },
//   { ioNo: 4, advertiser: '4', ioname: 'mymoney', iobrief: 'HNI property- lead generation- mumbai', iobudget: 10000, startDate: '2019-10-16', endDate: '2019-10-20' },
//   { ioNo: 5, advertiser: '4', ioname: 'mymoney', iobrief: 'HNI property- lead generation- mumbai', iobudget: 10000, startDate: '2019-10-16', endDate: '2019-10-20' },
//   { ioNo: 6, advertiser: '4', ioname: 'mymoney', iobrief: 'HNI property- lead generation- mumbai', iobudget: 10000, startDate: '2019-10-16', endDate: '2019-10-20' },
//   { ioNo: 7, advertiser: '4', ioname: 'mymoney', iobrief: 'HNI property- lead generation- mumbai', iobudget: 10000, startDate: '2019-10-16', endDate: '2019-10-20' },
//   { ioNo: 8, advertiser: '4', ioname: 'mymoney', iobrief: 'HNI property- lead generation- mumbai', iobudget: 10000, startDate: '2019-10-16', endDate: '2019-10-20' },
//   { ioNo: 9, advertiser: '4', ioname: 'mymoney', iobrief: 'HNI property- lead generation- mumbai', iobudget: 10000, startDate: '2019-10-16', endDate: '2019-10-20' },
//   { ioNo: 10, advertiser: '4', ioname: 'mymoney', iobrief: 'HNI property- lead generation- mumbai', iobudget: 10000, startDate: '2019-10-16', endDate: '2019-10-20' }
// ]